import { Viewport } from '@/hooks/useViewport'

/**
 * Feature/Page constants - add new features here as the app grows
 */

/**
 * Responsiveness will first be applied to the Learners Pages
 */

export const LEARNERS_SPECIFIC_PAGES = {
  MY_COURSES: 'my_courses',
  MY_CERTIFICATES: 'my_certificates',
} as const

export const LEARNING_MANAGERS_SPECIFIC_PAGES = {
  HOME: 'home',
  ADMINISTRATION: 'administration',
  PARTICIPANTS: 'participants',
  TRAININGS: 'trainings',
} as const

export const CUSTOMER_MANAGER_SPECIFIC_PAGES = {
  TENANTS: 'tenants',
  COURSE: 'course',
} as const

export const FEATURES = {
  AUTH: 'auth', // Login page
  ...LEARNERS_SPECIFIC_PAGES,
  ...LEARNING_MANAGERS_SPECIFIC_PAGES,
  ...CUSTOMER_MANAGER_SPECIFIC_PAGES,
} as const

export type FeatureName = (typeof FEATURES)[keyof typeof FEATURES]

/**
 * Viewport availability configuration per feature
 */
interface ViewportAvailability {
  mobile: boolean
  tablet: boolean
  desktop: boolean
}

/**
 * Feature availability matrix - explicit boolean per viewport
 *
 * Update this config as pages become responsive.
 */
export const FEATURE_AVAILABILITY: Record<FeatureName, ViewportAvailability> = {
  [FEATURES.HOME]: {
    mobile: false,
    tablet: false,
    desktop: true,
  },
  [FEATURES.MY_COURSES]: {
    mobile: true,
    tablet: true,
    desktop: true,
  },
  [FEATURES.MY_CERTIFICATES]: {
    mobile: true,
    tablet: true,
    desktop: true,
  },
  [FEATURES.PARTICIPANTS]: {
    mobile: false,
    tablet: false,
    desktop: true,
  },
  [FEATURES.TRAININGS]: {
    mobile: false,
    tablet: false,
    desktop: true,
  },
  [FEATURES.COURSE]: {
    mobile: false,
    tablet: false,
    desktop: true,
  },
  [FEATURES.TENANTS]: {
    mobile: false,
    tablet: false,
    desktop: true,
  },
  [FEATURES.ADMINISTRATION]: {
    mobile: false,
    tablet: false,
    desktop: true,
  },
  [FEATURES.AUTH]: {
    mobile: true,
    tablet: true,
    desktop: true,
  },
}

/**
 * Check if feature is available for a viewport.
 */
export const isFeatureAvailable = (feature: FeatureName, viewport: Viewport): boolean =>
  FEATURE_AVAILABILITY[feature]?.[viewport] ?? false
